export enum QuoteItemCategory {
  Risk = 'Risk',
  Party = 'Party',
}

export enum AttributeTypeCategory {
  Limit = 'Limit',
  Deductible = 'Deductible',
  CoverageOption = 'CoverageOption',
  RiskCharacteristic = 'RiskCharacteristic',
  Document = 'Document',
  Other = 'Other',
}

export enum DataType {
  String = 'String',
  StringList = 'StringList',
  Integer = 'Integer',
  Float = 'Float',
  Currency = 'Currency',
  DateTime = 'DateTime',
  Date = 'Date',
  Address = 'Address',
  Boolean = 'Boolean',
  Document = 'Document',
  DocumentList = 'DocumentList',
  // Artifact = "Artifact", //DMS ref
  // SelectOption = "SelectOption" // id, label
}

// FUTURE TODO: replace with UIFieldType enum from rule-engine
export enum UIFieldType {
  Textbox = 'Textbox',
  Select = 'Select',
  Date = 'Date',
  DateTime = 'DateTime',
  Checkbox = 'Checkbox',
  Radio = 'Radio',
  File = 'File',
  Percentage = 'Percentage',
  FilteredSelect = 'FilteredSelect',
  RadioButtonGroup = 'RadioButtonGroup',
}
